<template>
  <h1>KPI</h1>
</template>

<script>
export default {
  name: "KPI"
};
</script>

<style></style>
